<template>
    <div class="flex flex-col">
        <div class="inline-flex">
            <vx-basic-icon v-bind="icon" />
            <span
                class="ml-2 check-text inline-flex"
                :class="{ unchecked: !isFulfilled, optional: !isRequired }"
            >
                {{ description }}
            </span>
        </div>
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'
export default {
    name: 'vx-check-item',
    props: {
        isFulfilled: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {
        icon() {
            if (this.isFulfilled && this.isRequired) {
                return {
                    icon: 'CheckSquareIcon',
                    color: 'success'
                }
            }
            if (this.isFulfilled && !this.isRequired) {
                return {
                    icon: 'CheckSquareIcon',
                    color: 'warning'
                }
            }
            return {
                icon: 'SquareIcon',
                color: 'danger'
            }
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.check-text {
    color: rgba(var(--vs-success), 1);
    &.unchecked {
        color: rgba(var(--vs-danger), 1);
        font-weight: bold;
        &.has-link {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
                color: rgba(var(--vs-dark), 1);
                .link-icon {
                    opacity: 1;
                }
            }
        }
    }
    &.optional {
        color: rgba(var(--vs-warning), 1);
        font-weight: bold;
        &.has-link {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
                color: rgba(var(--vs-dark), 1);
                .link-icon {
                    opacity: 1;
                }
            }
        }
    }
}
.link-icon {
    color: rgba(var(--vs-dark), 1) !important;
    display: inline;
    transition: all 0.2s ease;
}
</style>
